// src/components/AIZoneFeedback.ts
import "./AIZoneFeedback.css";

const FEEDBACK_STORAGE_KEY = "ayesearch_ai_zone_feedback_queue";


function saveFeedback(responseText: string, feedback: string): void {
  try {
    const existingRaw = localStorage.getItem(FEEDBACK_STORAGE_KEY);
    const existing = existingRaw ? JSON.parse(existingRaw) : [];
    const queue = Array.isArray(existing) ? existing : [];

    queue.push({
      response: responseText,
      feedback,
      createdAt: new Date().toISOString(),
    });

    localStorage.setItem(
      FEEDBACK_STORAGE_KEY,
      JSON.stringify(queue.slice(-50)),
    );
  } catch {
    // Feedback UI remains usable even if local storage is unavailable.
  }
}

export function renderAIZoneFeedback(
  container: HTMLElement,
  responseText: string,
): void {
  container.innerHTML = `
    <div class="aiz-feedback-panel">
      <label class="aiz-feedback-label" for="aiz-feedback-input">
        What could be improved?
      </label>
      <textarea
        id="aiz-feedback-input"
        class="aiz-feedback-input"
        rows="3"
        maxlength="1200"
        placeholder="Tell AyeSearch what was incorrect, missing, or unclear."
      ></textarea>
      <div class="aiz-feedback-footer">
        <span class="aiz-feedback-status" aria-live="polite"></span>
        <button type="button" class="aiz-feedback-cancel">Cancel</button>
        <button type="button" class="aiz-feedback-submit">Submit feedback</button>
      </div>
    </div>
  `;

  const input = container.querySelector<HTMLTextAreaElement>(".aiz-feedback-input");
  const status = container.querySelector<HTMLElement>(".aiz-feedback-status");

  container
    .querySelector<HTMLButtonElement>(".aiz-feedback-cancel")
    ?.addEventListener("click", () => {
      container.hidden = true;
      container.innerHTML = "";
    });

  container
    .querySelector<HTMLButtonElement>(".aiz-feedback-submit")
    ?.addEventListener("click", () => {
      const feedback = input?.value.trim() || "";
      if (!feedback) {
        if (status) status.textContent = "Enter feedback first.";
        input?.focus();
        return;
      }

      saveFeedback(responseText, feedback);
      if (status) status.textContent = "Thanks — feedback saved.";
      if (input) input.value = "";

      window.setTimeout(() => {
        container.hidden = true;
        container.innerHTML = "";
      }, 900);
    });

  input?.focus();
}
